import { gsap } from "gsap"

let zoomIn = true
$('body').on('click', '.zoom-thumbnail', function (e){
  e.preventDefault()
  if(zoomIn) {
    zoomIn = false
    $(this).closest('.popup-content').find('.zoom-popup').addClass('open')

    gsap.fromTo('.zoom-popup .popup-row-left-col', { width: '30%'}, { width: '50%', duration: 1})
    gsap.fromTo('.zoom-popup .popup-zoom-overflow', { opacity: 0}, { opacity: 0.9, duration: 1, onComplete:allwoZoomOut})
  }

})

$('body').on('click', '.zoom-popup', function (e){
  e.preventDefault()
  if(zoomIn) {
    zoomIn = false
    gsap.fromTo('.zoom-popup .popup-row-left-col', { width: '50%'}, { width: '30%', duration: 1})
    gsap.fromTo('.zoom-popup .popup-zoom-overflow', { opacity: 0.9}, { opacity: 0, duration: 1, onComplete: removeZoomOveflow, onCompleteParams: [$(this)]})
  }
})

function allwoZoomOut()
{
  zoomIn = true
}

function removeZoomOveflow($this){
  zoomIn = true
  $this.removeClass('open')
}
